import Vue from 'vue'
import Vuex from 'vuex'
import sessionStoragePlugin from './sessionStorage';

import router from '../router'
import * as usersApiClient from '../js/usersApiClient';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [sessionStoragePlugin.plugin],
  state: {
      isUserLoggedIn: false,
      userRoles: [],
      user: {}
  },
  mutations: {
    loginUser: (state) => state.isUserLoggedIn = true,
    logoutUser: (state) => state.isUserLoggedIn = false,
  },
  actions: {
    async loginUser({commit, state}, credentials) {        
        const loginResponse = await usersApiClient.loginUserAsync(credentials);
        
        if (loginResponse) {
          state.userRoles = loginResponse.roles;
          state.user = loginResponse.user;
          commit('loginUser');
          
          if (state.userRoles.includes('admin')) {
            await router.push('/admin')
            return
          }

          await router.push('/profile')
        }
    },
    async logoutUser({commit}) {
        commit('logoutUser');
        sessionStoragePlugin.storage.removeItem();
        await router.push("/");
    },
    async updateUserData({state}, id) {
      const getUserResult = await usersApiClient.getUserAsync(id);
      
      if (getUserResult.success) {
        state.user = getUserResult.data;
      }
    }
  },
  modules: {
  }
})
